/*
    Formatação de CPF e telefone para exibição e digitação.

    Formatam progressivamente (funcionam com o valor incompleto), então servem tanto
    para mostrar um dado pronto quanto para mascarar enquanto o usuário digita.

    O backend sempre recebe só dígitos — use `soDigitos` antes de enviar.
*/

export const soDigitos = (valor: string): string => String(valor ?? "").replace(/\D/g, "");

export function formatarCPF(valor: string): string {
    const n = soDigitos(valor);

    if (n.length <= 3) return n;
    if (n.length <= 6) return `${n.slice(0, 3)}.${n.slice(3)}`;
    if (n.length <= 9) return `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6)}`;

    return `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6, 9)}-${n.slice(9, 11)}`;
}

export function formatarTelefone(valor: string): string {
    const n = soDigitos(valor);

    if (n.length <= 2) return n;
    if (n.length <= 6) return `(${n.slice(0, 2)}) ${n.slice(2)}`;
    if (n.length <= 10) return `(${n.slice(0, 2)}) ${n.slice(2, 6)}-${n.slice(6)}`;

    return `(${n.slice(0, 2)}) ${n.slice(2, 7)}-${n.slice(7, 11)}`;
}

/* Máscara do CPF quando oculto, mantendo o formato para não "pular" ao revelar. */
export const CPF_OCULTO = "•••.•••.•••-••";
